import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ReactPaginate from "react-paginate";
import { FaRedo } from "react-icons/fa";
import LineChatsReportsWise from "./LineChatsReportsWise";
import LineChats from "./LineChats";

export default function ViewReports(props) {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentPagelimit, setPageLimit] = useState(5);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const data = props.data || [];

  const userList = Object.entries(data).reduce((acc, [reportName, emails]) => {
    return [...acc, ...emails.map((email) => ({ email, reportName }))];
  }, []);

  const search_parameters = ["email","reportName"]; // Updated search parameters to match the structure of the user data

  let filteredData = userList;

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  function search() {
    return filteredData.filter((item) =>
      search_parameters.some((parameter) =>
        item[parameter].toString().toLowerCase().includes(query.toLowerCase())
      )
    );
  }

  const currentData = search().slice(
    (currentPage - 1) * currentPagelimit,
    (currentPage - 1) * currentPagelimit + currentPagelimit
  );

  const pageCount = Math.ceil(search().length / currentPagelimit);

  const handelepageclick = (data) => {
    setCurrentPage(data.selected + 1);
  };

  const findUsernameFromGmail = (gmailAddress) => {
    const parts = gmailAddress.split("@");
    if (parts.length === 2) {
      const usernameWithDot = parts[0];
      const usernameParts = usernameWithDot.split(".");
      if (usernameParts.length >= 2) {
        const firstName = capitalize(usernameParts[0]);
        const lastName = capitalize(usernameParts[1]);
        const lastNameRest = usernameParts.slice(2).join(" ");
        return (
          firstName + " " + lastName + (lastNameRest ? " " + lastNameRest : "")
        );
      } else {
        return "Invalid Gmail address. Must contain both first and last name.";
      }
    } else {
      return "Invalid Gmail address";
    }
  };

  const capitalize = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  function convertToDDMMYY(timestamp) {
    const date = new Date(timestamp);
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear().toString().slice(-2);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const seconds = date.getSeconds().toString().padStart(2, "0");

    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  const resetAll = () => {
    setCurrentPage(1);
    setQuery("");
  };

//   const dataItems = [
//     {
//         "reportName": "Regional Lab Activity",
//         "views": 308
//     },
//     {
//         "reportName": "Quality Review Dashboard",
//         "views": 242
//     },
//     {
//         "reportName": "OTD Tool",
//         "views": 136
//     },
//     {
//         "reportName": "Labs Data",
//         "views": 103
//     },
//     {
//         "reportName": "Lab Testing Demand Explorer",
//         "views": 60
//     },
//     {
//         "reportName": "LVP Tool",
//         "views": 51
//     },
//     {
//         "reportName": "OTD Simulation Tool",
//         "views": 41
//     },
//     {
//         "reportName": "LIMS Raw Data",
//         "views": 40
//     },
//     {
//         "reportName": "Labs Network 2.0",
//         "views": 38
//     },
//     {
//         "reportName": "Micro Incident Tool",
//         "views": 31
//     },
//     {
//         "reportName": "Lab Retesting",
//         "views": 30
//     },
//     {
//         "reportName": "Lab Audit & SCAPA Tool",
//         "views": 28
//     },
//     {
//         "reportName": "Priority Testing",
//         "views": 28
//     },
//     {
//         "reportName": "NIR Deep Dive",
//         "views": 23
//     },
//     {
//         "reportName": " NIR Governance",
//         "views": 21
//     },
//     {
//         "reportName": "Multi-mycotoxins Profile Report",
//         "views": 15
//     }
// ]
  return (
    <React.Fragment>
      <button
        style={{
          fontSize: "14px",
          padding: "12px",
          border: "none",
          width: "50px",
          borderRadius: "6px",
        }}
        onClick={handleClickOpen}
        title="View All"
      >
        <VisibilityIcon sx={{ fontSize: "18px" }} />
      </button>

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        id="viewallreports"
      >
        <DialogContent>
        <span
            className="personaWise"
            style={{
              fontWeight: "600",
              fontSize: "22px",
              paddingBottom: "1rem",
              display: "block",
            }}
          >
             Reports Analysis
          </span>
          <div>
            {/* <LineChatsReportsWise  data={data} /> */}
          </div>
          <span
            className="personaWise"
            style={{
              fontWeight: "600",
              fontSize: "22px",
              paddingBottom: "1rem",
              display: "block",
            }}
          >
            Group wise reports
          </span>
          <div
            style={{
              padding: "1rem",
              borderRadius: "6px",
              boxShadow: "0px 0px 4px",
            }}
          >
            <LineChats
              dataLoading={props.dataLoading}
              jsonData={props.dataItem}
            />
          </div>

          <span
            className="personaWise"
            style={{
              fontWeight: "600",
              fontSize: "22px",
              paddingBottom: "1rem",
              display: "block",
              paddingTop: "1rem",
            }}
          >
            User wise reports
          </span>

          <div
            style={{
              display: "flex",
              gridGap: "10px",
              alignItems: "center",
              alignContent: "center",
              margin: "5px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                paddingBottom: "1rem",
                paddingTop: "1rem",
                width: "100%",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gridGap: "10px",
                  alignContent: "center",
                  alignItems: "center",
                  width: "30%",
                }}
              >
                <div style={{ width: "100%" }} className="search-wrapper">
                  <input
                    type="search"
                    name="search-form"
                    id="search-form"
                    autoComplete="off"
                    value={query}
                    className="SearchBox_new"
                    placeholder="Search for Email"
                    onChange={(e) => {
                      setQuery(e.target.value);
                      handlePageChange({ selected: 1 });
                    }}
                  />
                </div>

                <div>
                  <Button
                    title="Reset all filters"
                    onClick={resetAll}
                    style={{
                      borderRadius: "6px",
                      textTransform: "capitalize",
                      fontSize: "16px",
                      display: "flex",
                      gridGap: "10px",
                      alignContent: "center",
                      alignItems: "center",
                      background: "#0000a0",
                      padding: "8px",
                      color: "white",
                      fontWeight: "600",
                      width: "auto",
                    }}
                    className="submit_btn"
                  >
                    <FaRedo />
                  </Button>
                </div>
              </div>

              <div
                style={{
                  display: "flex",
                  gridGap: "10px",
                  alignItems: "center",
                  alignContent: "center",
                }}
              >
                <div>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={3}
                    onPageChange={handelepageclick}
                    containerClassName={"pagination"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    activeClassName={"active"}
                    forcePage={currentPage - 1}
                  />
                </div>
              </div>
            </div>
          </div>

          <DialogContentText id="alert-dialog-description">
            <table id="AnalyticsTable">
              <thead>
                <tr>
                  <th>Email</th>
                  {/* <th>Name</th> */}
                  <th>Report</th>
                  {/* <th>Last Seen</th> */}
                </tr>
              </thead>

              <tbody>
                {currentData.map(({ email, reportName }, index) => (
                  <tr key={index}>
                    <td>{email}</td>
                    {/* <td>{findUsernameFromGmail(email)}</td> */}
                    <td>{reportName}</td>
                    {/* <td>{convertToDDMMYY(new Date().getTime())}</td> */}
                  </tr>
                ))}
              </tbody>
            </table>
          </DialogContentText>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingBottom: "1rem",
              paddingTop: "1rem",
              width: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                gridGap: "10px",
                alignItems: "center",
                alignContent: "center",
              }}
            >
              <div>
                <ReactPaginate
                  previousLabel={"Previous"}
                  nextLabel={"Next"}
                  breakLabel={"..."}
                  pageCount={pageCount}
                  marginPagesDisplayed={2}
                  pageRangeDisplayed={3}
                  onPageChange={handelepageclick}
                  containerClassName={"pagination"}
                  pageClassName={"page-item"}
                  pageLinkClassName={"page-link"}
                  previousClassName={"page-item"}
                  previousLinkClassName={"page-link"}
                  nextClassName={"page-item"}
                  nextLinkClassName={"page-link"}
                  breakClassName={"page-item"}
                  breakLinkClassName={"page-link"}
                  activeClassName={"active"}
                  forcePage={currentPage - 1}
                />
              </div>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
